import { useRouter } from "next/router";
import siteConfig from "../lib/siteConfig";
import content from "../content/footer";
import Address from "../components/Address";
import Icon from "./Icon";
import Link from "next/link";

export default function Footer({ companyInfo }) {
  const router = useRouter();
  return (
    <footer className="bg-brand-primary text-white">
      <div className="flex px-3 md:px-8 py-4 border-b border-b-white border-opacity-10">
        <nav className="flex flex-col md:flex-row">
          {content.navigation.map(({ label, url }) => {
            const isActive = router.pathname === url;
            const isExternal = url.startsWith("http");
            return (
              <Link
                key={label}
                href={url}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noopener noreferrer" : undefined}
                className="px-2 py-1 text-brand-primaryLighter flex items-center gap-1 hover:underline hover:text-white"
              >
                {label}
                {isExternal && <Icon name="externalLink" size="small"></Icon>}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="px-4 md:px-8 py-8">
        <div className="md:flex justify-between">
          <Address
            companyInfo={companyInfo}
            showRegistration={true}
            className="pb-4 md:pb-0 mb-4 md:mb-0 border-b border-b-white border-opacity-10 md:border-b-0"
          />
          <div className="flex flex-col content-end">
            <div className="text-lg font-semibold mb-1 md:text-end">
              {siteConfig.content.followUs}
            </div>
            <div className="md:self-end flex flex-col gap-2 md:gap-3">
              {companyInfo?.socials.instagram && (
                <a
                  href={companyInfo.socials.instagram}
                  target="_blank"
                  className="flex gap-2 hover:underline"
                >
                  <Icon name="instagram" size="large" />
                  <span>Instagram</span>
                </a>
              )}
              {companyInfo?.socials.facebook && (
                <a
                  href={companyInfo.socials.facebook}
                  target="_blank"
                  className="flex gap-2 hover:underline"
                >
                  <Icon name="facebook" size="large" />
                  <span>Facebook</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="md:text-center text-sm p-4 border-t border-t-white border-opacity-10 text-opacity-50">
        Kuvat{" "}
        <a
          className="font-semibold"
          target="_blank"
          rel="noopener noreferrer"
          href="https://koiravalokuvaustalapista.kuvat.fi/"
        >
          Paula Grekelä / Koiravalokuvausta Lapista
        </a>
        . Sivuston suunnittelu ja toteutus{" "}
        <a
          href="https://www.fantastic.fi"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold"
        >
          Fantastic Design
        </a>
      </div>
      <div className="text-center text-sm text-opacity-50 mb-4">
        {companyInfo?.name && (
          <>
            &copy; {new Date().getFullYear()} {companyInfo.name}
            {". "}
            {content.rightsReserved}
          </>
        )}
      </div>
    </footer>
  );
}
